// ** Icons Import
import { PieChart, Circle, Settings } from 'react-feather'

export default [
  {
    header: 'Billing Section'
  },
  {
    id: 'billing',
    title: 'Billing',
    icon: <Circle size={12} />,
    navLink: '/billing'
  }
]
